import { render, staticRenderFns } from "./UpdateSkuModal.vue?vue&type=template&id=088de8dc"
import script from "./UpdateSkuModal.vue?vue&type=script&lang=js"
export * from "./UpdateSkuModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports